var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResize011(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "resize-01 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.3514 4.13268H7.71533C5.69523 4.13268 4.05762 5.7703 4.05762 7.7904V22.4264C4.05762 24.4465 5.69523 26.0842 7.71533 26.0842H22.3514C24.3715 26.0842 26.0091 24.4465 26.0091 22.4264V7.7904C26.0091 5.7703 24.3715 4.13268 22.3514 4.13268Z",
    stroke: "#999999",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.03466 16.4946V19.7961L13.5132 15.3072L14.8039 16.5978L10.2943 21.11H13.65V22.873H7.26904V16.4946H9.03466Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.0428 13.7197V10.3975L16.5513 14.8864L15.2891 13.619L19.8038 9.1017H16.4171V7.34641H22.8007V13.7197H21.0428Z",
    fill: "#999999"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResize011);
export default __webpack_public_path__ + "static/media/resize-01 1.62a25ac89e26ada7c6dea692ebc986fc.svg";
export { ForwardRef as ReactComponent };